module.exports = __webpack_public_path__ + "media/images/AlarmClock-36fdff1a.svg";